import { topshotsAPI } from '../../app/api';
import { ISearchResults, SearchEntityType } from '@topshots/core-models';

interface SearchRequest {
  q: string;
  types?: SearchEntityType[];
}

const searchApi = topshotsAPI.injectEndpoints({
  endpoints: (build) => ({
    search: build.query<ISearchResults, SearchRequest>({
      query: (request) => ({
        url: 'search',
        method: 'GET',
        params: {
          q: request.q,
          types: request.types?.join(','),
        },
      }),
      keepUnusedDataFor: 10,
    }),
  }),
});

export const { useSearchQuery } = searchApi;
